import {useState} from 'react';

import {JSONValue} from 'util/Types';

import {VALUE_VALIDATORS} from './data/ValueValidators';
import {ParameterType} from './ParameterTypes';

interface UseAnalyticsParameterValueAndValidatorOutput {
  valueJson: JSONValue;
  valueJsonIsValid: boolean;
  updateValueJson: (newValueJson: JSONValue) => void;
}

export default function useAnalyticsParameterValueAndValidator<T extends ParameterType>(
  paramType: T,
  initialValueJson: JSONValue,
  onValueChange?: (newValue: JSONValue, newValueIsValid: boolean) => void
): UseAnalyticsParameterValueAndValidatorOutput {
  const validatorFn = VALUE_VALIDATORS[paramType];

  const [valueJson, setValueJson] = useState<JSONValue>(
    validatorFn(initialValueJson) ? initialValueJson : null
  );

  const [valueJsonIsValid, setValueJsonIsValid] = useState<boolean>(true);

  function updateValueJson(newValueJson: JSONValue): void {
    const newIsValid = validatorFn(newValueJson);

    setValueJsonIsValid(newIsValid);
    setValueJson(newValueJson);
    if (onValueChange) {
      onValueChange(newValueJson, newIsValid);
    }
  }

  return {valueJson, valueJsonIsValid, updateValueJson};
}
